
<div *ngFor="let banner of banners" class="tr-section tr-ad">
    <a href="{{banner.link}}" target="_blank">
        <img src="{{environment.staticContentUrl}}/uploads/image/{{banner.image}}_banner.jpg" class="img-responsive" alt="{{banner.title}} - creepyshake.com" title="{{banner.title}} - creepyshake.com"/>
    </a>
    <div _ngcontent-serverapp-c6="" class="ad-warning ad-warning-sidebar text-center">hirdetés</div>
</div>

